import { Message } from 'primeng/api';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserRegistrationService } from '../user-registration.service';
import { UserLoginService } from '../user-login.service';
import { LoggedInCallback } from '../cognito.service';


@Component({
    selector: 'app-confirm-registration',
    templateUrl: './confirm-registration.component.html'
})
export class RegistrationConfirmationComponent implements OnInit, OnDestroy {
    confirmationCode: string;
    email: string;
    errorMessages: Message[];
    private sub: any;

    constructor(public regService: UserRegistrationService, public router: Router, public route: ActivatedRoute) {
    }

    ngOnInit() {
        this.sub = this.route.params.subscribe({
            next: params => {
                this.email = params['email'];
            }
        });

        this.errorMessages = [];
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }

    onConfirmRegistration() {
        this.errorMessages = [];
        this.regService.confirmRegistration(this.email, this.confirmationCode, this);
    }

    cognitoCallback(message: string, result: any) {
        if (message != null) { // error
            this.errorMessages = [({ severity: 'error', detail: message })];
            console.log('message: ' + message);
        } else { // Success
            // move to the next step
            console.log('Moving to securehome');
            // this.configs.curUser = result.user;
            this.router.navigate(['/'], { queryParams: {} });
        }
    }
}




